import {getWebsiteId} from "./getWebsiteId";
import {isDevEnvironment} from "./isDevEnvironment";

const SHOP_URLS = {
  1: "https://shop.forthwithlife.co.uk",
  2: "https://shop.sportsbloodtests.co.uk",
  3: "https://shop.biomarkertracking.com",
};

const siteId = getWebsiteId();

export const getShopHostname = websiteId => {
  if (isDevEnvironment) {
    return window.location.hostname.includes("sportsbloodtests.co.uk")
      ? "https://appdev.sportsbloodtests.co.uk"
      : "https://appdev.forthwithlife.co.uk";
  }

  if (websiteId) return SHOP_URLS[websiteId] ?? window.location.origin;
  return SHOP_URLS[siteId] ?? window.location.origin;
};
